document.addEventListener('DOMContentLoaded', function() {
    const mainNavItems = document.querySelectorAll('.sb-mega-menu__main-item.has-sub-menu');

    mainNavItems.forEach(item => {
        const subItems = item.querySelectorAll('.sb-mega-menu__sub-item');

        item.addEventListener('mouseenter', () => {
            if (subItems.length > 0) {
                subItems[0].classList.add('active');
            }
        });

        item.addEventListener('mouseleave', () => {
            subItems.forEach(sub => {
                sub.classList.remove('active');
            });
        });

        subItems.forEach(subItem => {
            subItem.addEventListener('mouseenter', () => {
                subItems.forEach(s => s.classList.remove('active'));
                
                subItem.classList.add('active');
            });
        });
    });
});